export const PERMISSION_RESOURCES = [
  "trip",
  "reservation",
  "client",
  "employee",
  "analytics",
  "discountCode",
  "nationalId",
] as const;
export const PERMISSION_ACTIONS = ["get", "create", "update", "delete"] as const;
export const PERMISSION_RESOURCES_NO_MODIFY = ["employee", "analytics", "nationalId"] as const;

export const PERMISSIONS = [
  // Trip
  "trip:get",
  "trip:create",
  "trip:update",
  "trip:delete",
  // Reservation
  "reservation:get",
  "reservation:create",
  "reservation:update",
  "reservation:delete",
  // Client
  "client:get",
  "client:create",
  "client:update",
  "client:delete",
  // Employee (only "get")
  "employee:get",
  // Analytics (only "get")
  "analytics:get",
  // Discount Code
  "discountCode:get",
  "discountCode:create",
  "discountCode:update",
  "discountCode:delete",
  // National ID (only "get")
  "nationalId:get",
] as const;

export type TPermission = (typeof PERMISSIONS)[number];
export type TResource = (typeof PERMISSION_RESOURCES)[number];
export type TAction = (typeof PERMISSION_ACTIONS)[number];
